"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanelDetails.default;
  }
});

var _ExpansionPanelDetails = _interopRequireDefault(require("./ExpansionPanelDetails"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/ExpansionPanelDetails/index.js
// module id = 221
// module chunks = 107818501498521 169315112914517